"use client";

import { useState } from "react";
import { DemoVideoPlayer } from "./demo-video-player";
import { DemoVideoPlayer16x9 } from "./demo-video-player-16x9";
import { Button } from "@/components/ui/button";
import { cn } from "@/utils/ui";
import Link from "next/link";

const FORMATS = [
	{ id: "short", label: "Short, 9:16" },
	{ id: "wide", label: "Full video, 16:9" },
] as const;

const MADE = [
	["Script", "Hook, story arc and a closing question"],
	["Voices", "A different voice for each character"],
	["Visuals", "Keyframes and short animated clips"],
	["Finish", "Music, subtitles and the hook overlay"],
];

/** The two real demos behind a format toggle (one video visible at a time, so a phone loads one). */
export function DemoShowcase() {
	const [fmt, setFmt] = useState<(typeof FORMATS)[number]["id"]>("short");
	return (
		<div data-testid="demo-showcase">
			<div role="tablist" aria-label="Demo format" className="mb-7 inline-flex rounded-full border border-border-strong bg-card p-1">
				{FORMATS.map((f) => (
					<button
						key={f.id}
						role="tab"
						type="button"
						aria-selected={fmt === f.id}
						data-testid={`demo-tab-${f.id}`}
						onClick={() => setFmt(f.id)}
						className={cn("min-h-10 rounded-full px-5 text-sm font-semibold", fmt === f.id ? "bg-primary text-primary-foreground" : "text-muted-foreground hover:text-foreground")}
					>
						{f.label}
					</button>
				))}
			</div>
			<div className="grid items-center gap-8 rounded-2xl border border-border bg-card p-6 sm:p-8 lg:grid-cols-[1fr_1fr] lg:gap-12">
				<div className="flex justify-center">
					{fmt === "short" ? (
						<div className="w-[min(260px,70vw)] overflow-hidden rounded-[2rem] border border-border-strong bg-card p-2">
							<div className="aspect-[9/16] overflow-hidden rounded-[1.5rem] bg-black"><DemoVideoPlayer /></div>
						</div>
					) : (
						<div className="w-full max-w-2xl"><DemoVideoPlayer16x9 /></div>
					)}
				</div>
				<ul className="grid gap-5 lg:pr-6">
					{MADE.map(([t, d], i) => (
						<li key={t} className="grid grid-cols-[28px_1fr] gap-3">
							<span className="grid size-7 place-items-center rounded-md bg-secondary text-xs font-bold text-secondary-foreground">{i + 1}</span>
							<span><b className="block text-sm">{t}</b><em className="text-sm not-italic text-muted-foreground">{d}</em></span>
						</li>
					))}
					<li><Button asChild className="min-h-11"><Link href="/login">Make yours free</Link></Button></li>
				</ul>
			</div>
		</div>
	);
}
